import React from 'react'

export default function Footer() {
    return <footer>Made with love ♥ By Jared Bowman</footer>
}
